var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTtGreen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.543992 1.97656V0.181818H11.2382V1.97656H6.9268V14H4.84868V1.97656H0.543992ZM19.4172 3.63636V5.25568H13.7563V3.63636H19.4172ZM15.2745 1.15341H17.2919V10.957C17.2919 11.3484 17.3503 11.643 17.4673 11.8409C17.5842 12.0343 17.7349 12.167 17.9193 12.239C18.1083 12.3065 18.3129 12.3402 18.5333 12.3402C18.6953 12.3402 18.837 12.329 18.9584 12.3065C19.0799 12.284 19.1743 12.266 19.2418 12.2525L19.6061 13.919C19.4892 13.964 19.3228 14.009 19.1068 14.054C18.8909 14.1035 18.621 14.1304 18.2972 14.1349C17.7664 14.1439 17.2716 14.0495 16.8128 13.8516C16.354 13.6536 15.9829 13.3478 15.6995 12.9339C15.4161 12.5201 15.2745 12.0006 15.2745 11.3754V1.15341Z",
    fill: "#10A37F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTtGreen);
export default __webpack_public_path__ + "static/media/TtGreen.09d457dc6c71aad4b13792367ff97878.svg";
export { ForwardRef as ReactComponent };